import { useSuspenseQuery } from '@tanstack/react-query'
import { useZAFClient } from './useZafClient'

// Some templates use webhooks with Zendesk events and no triggers
export const useWebhookSubscriptions = (): string[] => {
  const zafClient = useZAFClient()

  const { data: webhookSubscriptions } = useSuspenseQuery({
    queryKey: ['zendesk', 'webhookSubscriptions'],
    queryFn: async (): Promise<string[]> => {
      if (!zafClient) return []
      const { settings } = await zafClient.metadata()

      try {
        return settings.webhookSubscriptions.split(',')
      } catch {
        return []
      }
    },
  })

  return webhookSubscriptions
}
